module.exports = __webpack_public_path__ + "static/img/goTop.5a9d6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goTop.png
// module id = 2WLZ
// module chunks = 1